"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.TranslationKey = void 0;
/* istanbul ignore file @preserve */ /**
 * DO NOT EDIT!
 * This file was autogenerated by npm script `localizations-codegen`.
 * Changes may cause incorrect behavior and will be lost when the file is regenerated.
 *
 * Run `npx localizations-codegen` to regenerate.
 */ let TranslationKey = exports.TranslationKey = /*#__PURE__*/ function(TranslationKey) {
    TranslationKey["accountBalance"] = "accountBalance";
    TranslationKey["add"] = "add";
    TranslationKey["addCodeHere"] = "addCodeHere";
    TranslationKey["addVoucher"] = "addVoucher";
    TranslationKey["applied"] = "applied";
    TranslationKey["atLeastOneProductMustBeOrdered"] = "atLeastOneProductMustBeOrdered";
    TranslationKey["atpIsDepletedByOtherProcess"] = "atpIsDepletedByOtherProcess";
    TranslationKey["availableToUseNow"] = "availableToUseNow";
    TranslationKey["bonusPoints"] = "bonusPoints";
    TranslationKey["bonusPointsFromPlacedOrdersInCampaign"] = "bonusPointsFromPlacedOrdersInCampaign";
    TranslationKey["bp"] = "bp";
    TranslationKey["bpCount"] = "bpCount";
    TranslationKey["byClickingFinaliseOrder"] = "byClickingFinaliseOrder";
    TranslationKey["cannotOrderSubscriptionBecauseYourDeliveryIsNotOriflameCertifiedOffice"] = "cannotOrderSubscriptionBecauseYourDeliveryIsNotOriflameCertifiedOffice";
    TranslationKey["cannotOrderSubscriptionBecauseYourLeaderIsNotAuthorized"] = "cannotOrderSubscriptionBecauseYourLeaderIsNotAuthorized";
    TranslationKey["continue"] = "continue";
    TranslationKey["credibilityCheckFailed"] = "credibilityCheckFailed";
    TranslationKey["credit"] = "credit";
    TranslationKey["creditIsNotAllowedForCustomersOrder"] = "creditIsNotAllowedForCustomersOrder";
    TranslationKey["currentActionIsDisabledDuringMaintenance"] = "currentActionIsDisabledDuringMaintenance";
    TranslationKey["deliveryAddressIsNotAllowedForACustomer"] = "deliveryAddressIsNotAllowedForACustomer";
    TranslationKey["deliveryAddressIsRequired"] = "deliveryAddressIsRequired";
    TranslationKey["deliveryAddressOfACustomerIsNotFound"] = "deliveryAddressOfACustomerIsNotFound";
    TranslationKey["deliveryChannelIsNotAllowedForACustomer"] = "deliveryChannelIsNotAllowedForACustomer";
    TranslationKey["discount"] = "discount";
    TranslationKey["endConsumerOrderIsAlreadyDroppedOnDifferentOrder"] = "endConsumerOrderIsAlreadyDroppedOnDifferentOrder";
    TranslationKey["errorCode"] = "errorCode";
    TranslationKey["finaliseOrder"] = "finaliseOrder";
    TranslationKey["financeAccountWasAlreadyConsumed"] = "financeAccountWasAlreadyConsumed";
    TranslationKey["group"] = "group";
    TranslationKey["homeDelivery"] = "homeDelivery";
    TranslationKey["homeDeliveryAddressDoesntMatchZipTree"] = "homeDeliveryAddressDoesntMatchZipTree";
    TranslationKey["insufficientPrepaymentForPharmacyOrdering"] = "insufficientPrepaymentForPharmacyOrdering";
    TranslationKey["invalidShoppingOperation"] = "invalidShoppingOperation";
    TranslationKey["items"] = "items";
    TranslationKey["logIn"] = "logIn";
    TranslationKey["meanwhileHaveBeenChangeCataloguesOrRules"] = "meanwhileHaveBeenChangeCataloguesOrRules";
    TranslationKey["meanwhileHaveBeenPlacedOtherOrder"] = "meanwhileHaveBeenPlacedOtherOrder";
    TranslationKey["ok"] = "ok";
    TranslationKey["orderSummary"] = "orderSummary";
    TranslationKey["paidWithOriflameWallet"] = "paidWithOriflameWallet";
    TranslationKey["paymentFee"] = "paymentFee";
    TranslationKey["paymentMethodIsNotAllowed"] = "paymentMethodIsNotAllowed";
    TranslationKey["personal"] = "personal";
    TranslationKey["pickUpPointDelivery"] = "pickUpPointDelivery";
    TranslationKey["placingOrderForTestingShoppingSessionIsNotAllowed"] = "placingOrderForTestingShoppingSessionIsNotAllowed";
    TranslationKey["placingOrderWithoutFinishedRegistrationIsNotAllowed"] = "placingOrderWithoutFinishedRegistrationIsNotAllowed";
    TranslationKey["pleaseWaitAsItsTakingLongerThanExpected"] = "pleaseWaitAsItsTakingLongerThanExpected";
    TranslationKey["prepaidRemainingX"] = "prepaidRemainingX";
    TranslationKey["productDimensionCanNotFitToTheShoppingBox"] = "productDimensionCanNotFitToTheShoppingBox";
    TranslationKey["productWeightIsOverSmartboxLimit"] = "productWeightIsOverSmartboxLimit";
    TranslationKey["registerToContinue"] = "registerToContinue";
    TranslationKey["registrationFee"] = "registrationFee";
    TranslationKey["renewalFee"] = "renewalFee";
    TranslationKey["servicesAlreadyDroppedOnDifferentOrder"] = "servicesAlreadyDroppedOnDifferentOrder";
    TranslationKey["subtotal"] = "subtotal";
    TranslationKey["thisMayTakeAMoment"] = "thisMayTakeAMoment";
    TranslationKey["ticketQuantityIsDepletedByOtherProcess"] = "ticketQuantityIsDepletedByOtherProcess";
    TranslationKey["toOrderThisSubscriptionYouNeed"] = "toOrderThisSubscriptionYouNeed";
    TranslationKey["toOriflameWallet"] = "toOriflameWallet";
    TranslationKey["toPay"] = "toPay";
    TranslationKey["unableToContinue"] = "unableToContinue";
    TranslationKey["unauthorizedAccess"] = "unauthorizedAccess";
    TranslationKey["underOrderAmountLimit"] = "underOrderAmountLimit";
    TranslationKey["voucherCode"] = "voucherCode";
    TranslationKey["voucherCodeIsRequired"] = "voucherCodeIsRequired";
    TranslationKey["voucherCodeIsTooLong"] = "voucherCodeIsTooLong";
    TranslationKey["voucherIsDepletedByOtherProcess"] = "voucherIsDepletedByOtherProcess";
    TranslationKey["wallet"] = "wallet";
    TranslationKey["walletIsAutoAppliedAndCanCoverUpToXOfYourOrder"] = "walletIsAutoAppliedAndCanCoverUpToXOfYourOrder";
    TranslationKey["weAreProcessingYourOrder"] = "weAreProcessingYourOrder";
    TranslationKey["yourOrderIsSaved"] = "yourOrderIsSaved";
    TranslationKey["yourOrderIsSavedPaymentRedirect"] = "yourOrderIsSavedPaymentRedirect";
    return TranslationKey;
}({});
